import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { FlujoVentaPasoOcupacion } from '../_models/flujo-venta-paso-ocupacion';

@Injectable({
  providedIn: 'root'
})
export class FlujoVentaPasoOcupacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/flujoVentaPasosOcupaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as FlujoVentaPasoOcupacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as FlujoVentaPasoOcupacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as FlujoVentaPasoOcupacion ) );
  }

  listadoPorIdFlujoPaso( id: string ) {
    return this.httClient.get( this.rutServicio + '/idFlujoVentaPaso/' + id ).pipe( map( res => res as FlujoVentaPasoOcupacion[] ) );
  }

  crear( regCrear: FlujoVentaPasoOcupacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as FlujoVentaPasoOcupacion ) );
  }

  actualizar( regActualizar: FlujoVentaPasoOcupacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as FlujoVentaPasoOcupacion ) );
  }

  bulk( registros: FlujoVentaPasoOcupacion[] ) {
    registros.forEach( e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( `${ this.rutServicio }/bulk`, registros ).pipe( map( res => res as FlujoVentaPasoOcupacion[] ) );
  }
}
